<template>
  <div
    class="ui labeled basic icon button"
    @click="back">
    <i class="long arrow alternate left icon"/>
    {{ $t('navigation.back') }}
  </div>
</template>

<script>
export default {
  name: 'BackButton',
  methods: {
    back () {
      let newPath = this.$route.path
        .split('/')
        .slice(0, 2)
        .join('/')

      this.$router.push(newPath)
    }
  }
}
</script>
